export default {
  BARRAMENTO_API_URL: process.env.REACT_APP_BARRAMENTO_API_URL,
  BARRAMENTO_PLAYGROUND_CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
  YANDEH_HUB_REALM: process.env.REACT_APP_REALM,
  TOKEN_BARRAMENTO_KEY: 'playgroundToken',
};
